import { combineReducers } from 'redux';
import {
  FETCH_ADMINS_REQUEST,
  FETCH_ADMINS_SUCCESS,
  FETCH_ADMINS_FAILURE,
  FETCH_ADMIN_BY_ID_REQUEST,
  FETCH_ADMIN_BY_ID_SUCCESS,
  FETCH_ADMIN_BY_ID_FAILURE,
  FETCH_SELF_REQUEST,
  FETCH_SELF_SUCCESS,
  FETCH_SELF_FAILURE,
} from '../../constants/ActionTypes';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ADMINS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ADMINS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
        paging: action.data.paging,
      };
    case FETCH_ADMINS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const selected = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ADMIN_BY_ID_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ADMIN_BY_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ADMIN_BY_ID_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const self = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_SELF_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_SELF_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_SELF_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const admins = combineReducers({
  list,
  selected,
  self,
});

export default admins;
